import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../lib/client.js'
import { resolveInsurancePaymentRequest } from './insurance-payment-request.js'

interface InitiateInsurancePaymentResponse {
  axeptaRedirectUrl: string
}

export const useInitiateInsurancePaymentMutation = () =>
  useMutation({
    mutationFn: async ({ bookingId, sessionId }: { bookingId?: string; sessionId?: string }) => {
      const request = resolveInsurancePaymentRequest({ bookingId, sessionId })

      if (!request) {
        throw new Error('Aucun contexte sécurisé disponible pour initier le paiement assurance.')
      }

      const response = await apiClient.client.post<InitiateInsurancePaymentResponse>(
        request.url,
        request.payload
      )
      return response.data
    },
  })

/**
 * Download a payment receipt PDF by Axepta TransID (public endpoint).
 * Handles both BookingPayment and LegacyPaymentRequest (pre-launch dossiers).
 */
export const useDownloadPublicPaymentReceiptPdfMutation = () =>
  useMutation({
    mutationFn: async (externalId: string): Promise<Blob> => {
      const response = await apiClient.client.get<Blob>(
        `/payment/public/receipt/${externalId}`,
        { responseType: 'blob' }
      )
      return response.data
    },
  })

